import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import IconButton from '@ey/canvascoreservices/IconButton';
import {Modal} from '@ey/canvascoreservices';
import {documentTypes, entities, GALinkStatus, clientSideEventNames} from '../../../../../../../../../util/uiconstants';
import {raiseJSValidationError} from '../../../../../../../../../actions/erroractions';
import {createEntityForm} from '../../../../../../../../../actions/EntityForms/entityformsactions';
import {useAresUrlParameters} from '../../../../../../../../../util/Ares/customHooks';
import {getTaskDocumentByDocumentId} from '../../../../../../../../../selectors/Ares/selectors';
import LoadingIndicator from '../../../../../../../LoadingIndicator/LoadingIndicator';
import {currentResource} from '../../../../../../../../../util/utils';
import Utility from '../../../../../../../../../util/utilityfunctions';
import {OutputText} from '@ey/canvascoreservices';
import StyledMotifToast from '../../Common/MotifToast/StyledMotifToast';
import StyledLinkButton from '../../Common/MotifToast/StyledLinkButton';
import StyledListItems from './StyledListItems';
import {setFormV2ToasterVisibility} from '../../../../../../../../../actions/toastactions';

export default function CreateGroupInvolvementDocModal() {
	const labels = currentResource.groupInvolvement;
	const [showModalTrigger, setShowModalTrigger] = useState(false);
	const [showSuccessBanner, setShowSuccessBanner] = useState(false);
	const components = useSelector(({groupAudit}) => groupAudit?.components);

	const giComponentWithNoDocument = components?.data?.filter(
		(data) => data?.relatedDocuments?.length === 0 && data?.linkRequest !== GALinkStatus.ReferenceOnly
	);

	useEffect(() => {
		if (giComponentWithNoDocument?.length > 0) {
			setShowModalTrigger(true);
		} else {
			setShowModalTrigger(false);
		}
	}, [components]);

	const cfAlphanum = (a, b) => a?.localeCompare(b, undefined, {sensitivity: 'base', numeric: true});
	const cfNumber = (a, b) => {
		if (a === b) return 0;
		if (a === null) return 1;
		if (b === null) return -1;
		return a < b ? -1 : 1;
	};

	const {taskId, engagementId, documentId} = useAresUrlParameters();
	const dispatch = useDispatch();
	const taskDocument = useSelector((store) => getTaskDocumentByDocumentId(store, documentId));
	const getTaskId = () => {
		if (taskId) {
			return taskId;
		}
		if (taskDocument && taskDocument.taskId) {
			return taskDocument.taskId;
		}
		return null;
	};
	const orderedGIComponentNoWithDocument = giComponentWithNoDocument?.sort(
		(a, b) => cfNumber(a?.name, b?.name) || cfAlphanum(a?.name, b?.name)
	);

	const renderTrigger = () => {
		const onClick = () => {
			const _taskId = getTaskId();
			const createPayload = (component) => {
				return {
					entityId: entities.GaComponent,
					documentTypeId: documentTypes.GROUP_INVOLVEMENT_INDIVIDUAL_COMPONENT,
					taskId: _taskId,
					objectIds: [component.id]
				};
			};
			let promiseArray = [];
			orderedGIComponentNoWithDocument.forEach((component) => {
				const payload = createPayload(component);
				promiseArray.push(dispatch(createEntityForm(engagementId, payload)));
			});

			Promise.allSettled(promiseArray).then((results) => {
				let failedComponents = [];
				results.forEach((res) => {
					if (res.status === 'rejected') {
						const data = JSON.parse(res?.reason?.config?.data);
						failedComponents = failedComponents.concat(data.GAComponents);
					}
				});
				if (failedComponents.length > 0) {
					const components = failedComponents.map((fc) =>
						orderedGIComponentNoWithDocument.find((comp) => fc === comp.id)
					);
					let errorMessage = labels.createGroupInvolvementDocumentErrorMessage;
					errorMessage = errorMessage.replace('{0}', components.map(({name}) => name).join(', '));
					dispatch(raiseJSValidationError(errorMessage));
				} else {
					setShowSuccessBanner(true);
					setShowModalTrigger(false);
				}
				window.dispatchEvent(new CustomEvent(clientSideEventNames.getValidations));
			});
		};

		const props = {
			label: labels.CreateGroupInvolvementHeader,
			onClick,
			showLabel: true,
			variant: 'text-alt',
			className: 'styled-link-button'
		};
		const title =
			labels.GroupInvolvementToastMsgStart + giComponentWithNoDocument?.length + labels.GroupInvolvementToastMsgEnd;

		return (
			<StyledMotifToast variant="warning" className="componentInstructionToast">
				<OutputText body2>{title}</OutputText>
				<StyledLinkButton>
					<IconButton {...props} />
				</StyledLinkButton>
			</StyledMotifToast>
		);
	};

	const renderSuccessBanner = () => {
		let successMsg = labels.createGroupInvolvementDocumentSuccessMessage;
		dispatch(setFormV2ToasterVisibility(true, 'success', successMsg)).then(() => {
			setShowSuccessBanner(false);
			setTimeout(() => {
				dispatch(setFormV2ToasterVisibility(false, '', ''));
			}, 3000);
		});
	};

	const renderDescription = () => {
		const title = labels.GroupInvolvementInstructionalText;
		const outputTextProps = {size: 'L'};

		return <OutputText {...outputTextProps}>{Utility.createRichTextElement(title)}</OutputText>;
	};

	const renderComponentList = () => {
		const renderScope = () => {
			return (
				orderedGIComponentNoWithDocument.length > 0 && (
					<StyledListItems className="customScrollbar">
						{orderedGIComponentNoWithDocument.map((y) => {
							const componentNameProps = {size: 'L'};

							return (
								<div className="components">
									<OutputText {...componentNameProps}>{y.name}</OutputText>
								</div>
							);
						})}
					</StyledListItems>
				)
			);
		};

		return <>{renderScope()}</>;
	};

	/*const renderModal = () => {
		const onCloseModal = () => {
			setIsLoading(false);
			setShowCreateDocumentsModal(false);
		};


		const modalProps = {
			show: showCreateDocumentsModal,
			size: 'small AresModal',
			headerText: labels.CreateGroupInvolvementHeader,
			labels: {
				modalConfirmBtnLabel: gsLabels.createInstructionsModalmodalConfirmBtnLabel,
				modalCancelBtnLabel: gsLabels.createInstructionsModalmodalCancelBtnLabel,
				modalCloseBtnTitletip: gsLabels.createInstructionsModalmodalCloseBtnTitletip
			},
			onClose: onCloseModal,
			onCancelClick: onCloseModal,
			onOkClick: handleCreateInstructions
		};

		return (
			<Modal {...modalProps}>
				{renderDescription()}
				{!isLoading && renderComponentList()}
				{isLoading && <LoadingIndicator view="inlineView" />}
			</Modal>
		);
	};*/

	return (
		<>
			{showModalTrigger && renderTrigger()}
			{/*{showCreateDocumentsModal && renderModal()}*/}
			{showSuccessBanner && renderSuccessBanner()}
		</>
	);
}
